var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-google-map-search-box"},[_c('input',{staticClass:"input controls",attrs:{"id":this._uid+'-search-input',"type":"text","placeholder":"Search..."}})])}
var staticRenderFns = []

export { render, staticRenderFns }